
import Expanded from './expanded.vue'
import Onboarding from './onboarding.vue'

export default {
  components: {Expanded, Onboarding},
  props: {
    chatId: {type: String, default: undefined},
    mode: {type: String, required: true},
    item: {type: Object, required: true},
    lastAnswer: {type: Boolean, default: false},
    generating: {type: Boolean, default: false},
    idx: {type: Number, default: 0},
    readonly: {type: Boolean, default: false},
    restricted: {type: Boolean, default: false},
  },
  emits: [
    'text-added', 'ask-ai', 'refrag', 
    'save', 'dislike', 'like', 
    'onboarding-completed'
  ],
  computed: {
    data(){
      return this.item?.data
    }
  },
  created() {
    this.$listen('document-save', this.saveDocument)
  },
  methods: {
    async saveDocument(args = {}) {
      const {card_idx, ext} = args
      const rendered_widgets = await this.$refs.expanded.getRenderedWidgets()
      this.$dispatch('document-save', {
        history_idx: this.idx,
        card_idx,
        ext,
        rendered_widgets
      })
    },
    getAnswerTabs(){
      return this.$refs.expanded.getAnswerTabs()
    }
  },

}
